module.exports = __webpack_public_path__ + "img/NYI-Logo-Navy.cec58d7c.svg";